import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';
import PageLayout from 'src/components/common/PageLayout';
import { ADD_ROUTE, LOGIN_ROUTE, PRAYER_HUB_ROUTE, PRAYER_ROUTE, PROFILE_ROUTE, ROOT } from 'src/constants/routes';

import PrivateRoute from './components/common/PrivateRoute';
import CreateHub from './components/pages/CreateHub';
import Login from './components/pages/Login';
import Main from './components/pages/Main';
import MainMobile from './components/pages/MainMobile';
import PrayerPage from './components/pages/Prayer';
import PrayerHub from './components/pages/PrayerHub';
import Profile from './components/pages/Profile';

export const Routes = (
  <>
    <Route path={ROOT} element={<PageLayout />}>
      <Route path={ROOT} element={<MainMobile />} />
      <Route path={PRAYER_ROUTE} element={<PrayerPage />} />
      <Route path={PRAYER_HUB_ROUTE} element={<PrayerHub />} />
      <Route
        path={PROFILE_ROUTE}
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path={ADD_ROUTE}
        element={
          <PrivateRoute>
            <CreateHub />
          </PrivateRoute>
        }
      />
      <Route path={LOGIN_ROUTE} element={<Login />} />
    </Route>
  </>
);

export const routes = createRoutesFromElements(Routes);
export default routes;
